import { GridColDef, GridSortModel } from '@mui/x-data-grid-pro';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { SingleOperators } from 'common/src/query-params/operators';
import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';
import { CredentialType } from 'common/src/types/enums/CredentialType.enum';
import { ICredential, IPage } from 'common/src/types/interfaces';

import { QUERY_KEYS } from 'portal/src/api/constants';
import {
  deleteCredential,
  getCredentials,
} from 'portal/src/api/CredentialsService';
import DataTable from 'portal/src/components/common/DataTable';
import { NEW_ID } from 'portal/src/constants/ReservedIDs';

import getGridColumns from './UtilityCredentials.columns';

const defaultSortModel: GridSortModel = [{ field: 'utilityName', sort: 'asc' }];

const UtilityCredentials = () => {
  const navigate = useNavigate();

  const {
    data: credentials,
    isFetching,
    isError,
    refetch,
  } = useQuery({
    queryKey: [QUERY_KEYS.credentials],
    queryFn: async () =>
      await getCredentials({
        filters: [
          {
            field: 'type',
            operator: SingleOperators.EQUALS,
            value: CredentialType.Utility,
          },
          {
            field: 'isActive', // Only show non soft-deleted credentials
            operator: SingleOperators.EQUALS,
            value: true,
          },
        ],
      }),
    initialData: { data: [] } as IPage<ICredential>,
  });

  const gridColumns: GridColDef[] = getGridColumns();

  const handleNavigate = (id: string) => navigate(`./${id}`);

  return (
    <DataTable
      actionsConfig={{
        readActionConfig: {
          onClick: (id) => handleNavigate(id),
        },
        deleteConfig: {
          targetStr: 'credential',
          onDeleteClick: async (id) => {
            await deleteCredential(id);
            await refetch();
          },
          snackbarMsgKey: 'CREDENTIAL',
        },
      }}
      checkboxSelection={false}
      columns={gridColumns}
      contextName={NESTED_ROUTES.BILL_AUTOMATION.CREDENTIALS}
      dataFetchError={isError}
      initialState={{ sorting: { sortModel: defaultSortModel } }}
      loading={isFetching}
      rows={credentials.data}
      toolbarSlotProps={{
        onNewButtonClick: () => handleNavigate(NEW_ID),
        showFilters: true,
      }}
    />
  );
};

export default UtilityCredentials;
